import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  selector: 'sbnb-minut',
  template: `
    <sbnb-apps-detail-page
      vendorCode="minut"
      name="Minut"
      logoTile="/assets/images/apps/minut.svg"
      builtBy="Minut"
      builtByLink="https://www.minut.com/"
      [categories]="['Monitoring']"
      [permissions]="[AppPermission.propertyListingRead, AppPermission.reservationRead]"
      email="hello@minut.com"
      [helpArticles]="[
        {
          id: '7206433',
          title: 'How to Integrate Minut Noise Monitor',
        },
      ]">
      <ng-container description>
        <div class="space-y-4">
          <p>
            Minut is a single platform and device for privacy-first noise and occupancy monitoring, AI-powered cigarette
            smoke detection, temperature, and humidity monitoring. Founded in 2014, its guest-friendly and
            community-first innovations are trusted by over 50,000 leading property managers around the world to make
            stays comfortable, safe, and secure. Minut empowers teams with the information they need to create and scale
            hospitality businesses that safeguard stays, evolve the guest experience, and help communities thrive.
          </p>

          <p><strong>Import stay information from Hospitable</strong></p>

          <p>
            The integration with Hospitable lets Minut get reservation and guest information from your booking calendar.
            If a Minut sensor detects noise in your property, this integration will automatically send a text message to
            the guest currently staying there (if any), letting them know to keep it down.
          </p>

          <p><strong>Key integration features:</strong></p>

          <ul class="space-y-3 list-disc pl-5 leading-normal">
            <li>Sync reservation information from Hospitable.</li>
            <li>Send guests an SMS when noise is above the threshold.</li>
            <li>Autocall guests when noise is above the threshold.</li>
          </ul>

          <p>Get started with the integration by connecting Hospitable in the Minut web app.</p>

          <p>
            Questions? Check out our
            <a
              href="https://support.minut.com/en/articles/7208052-connect-with-hospitable"
              target="_blank"
              class="text-blue-600 hover:text-blue-800">
              help center
            </a>
            or contact us at
            <a href="mailto:hello@minut.com" target="_blank" class="text-blue-600 hover:text-blue-800">
              hello&#64;minut.com
            </a>
            .
          </p>
        </div>
      </ng-container>
      <sbnb-image-carousel
        [images]="['/assets/images/apps/minut/1.jpg', '/assets/images/apps/minut/2.jpg']"></sbnb-image-carousel>
    </sbnb-apps-detail-page>
  `,
})
export class MinutComponent {
  public AppPermission = AppPermission;
}
